<template>
  <base-drawer :show="show" title="Send email" @close="onClose">
    <!-- v-if remounts the view on every open so templates reload and the form resets. -->
    <send-email-view
      v-if="show"
      context="transaction"
      :transaction="transaction"
      :rows="rows"
      :company-id="companyId"
      :company-group-id="companyGroupId"
      :email-settings="emailSettings"
      hosted
      ref="view"
      @back="onClose"
      @sent="onSent"
      @state="viewState = $event"
    />
    <template v-if="show && viewState.hasAnyOption" #footer>
      <div class="footer-actions">
        <base-button type="secondary" size="sm" :disabled="viewState.sending" @click="onClose">Cancel</base-button>
        <base-button type="primary" size="sm" :disabled="!viewState.canSend || viewState.sending" @click="send">
          <span v-if="viewState.sending">Sending...</span>
          <span v-else>Send email</span>
        </base-button>
      </div>
    </template>
  </base-drawer>
</template>

<script>
import SendEmailView from '@/components/SendEmailView.vue';

export default {
  name: 'SendEmailDrawer',

  components: { SendEmailView },

  props: {
    show: { type: Boolean, default: false },
    // { id, email, status, due }
    transaction: { type: Object, default: null },
    // The transaction page's mixed rows: bookings, items, gift cards.
    rows: { type: Array, default: () => [] },
    // [{ email_type, is_active }]
    emailSettings: { type: Array, default: () => [] },
    companyId: { type: [Number, String], default: null },
    companyGroupId: { type: [Number, String], default: null }
  },

  emits: ['close', 'sent'],

  data() {
    return {
      viewState: { canSend: false, sending: false, hasAnyOption: false, loading: true }
    };
  },

  watch: {
    show(newVal) {
      if (newVal) {
        this.viewState = { canSend: false, sending: false, hasAnyOption: false, loading: true };
        document.addEventListener('keydown', this._onEscKey);
      } else {
        document.removeEventListener('keydown', this._onEscKey);
      }
    }
  },

  created() {
    this._onEscKey = (e) => {
      if (e.key === 'Escape' && this.show) {
        this.onClose();
      }
    };
  },

  beforeDestroy() {
    document.removeEventListener('keydown', this._onEscKey);
  },

  methods: {
    onClose() {
      this.$emit('close');
    },
    send() {
      if (this.$refs.view) {
        this.$refs.view.send();
      }
    },
    onSent(payload) {
      this.$emit('sent', payload);
      this.onClose();
    }
  }
};
</script>
